import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Toaster } from "../components/ui/sonner";
import { adminLogin, setToken, getToken, adminMe } from "../lib/api";
import { COMPANY } from "../lib/content";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    const t = getToken();
    if (!t) return;
    adminMe().then(() => nav("/admin")).catch(() => setToken(null));
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { token } = await adminLogin(email, password);
      setToken(token);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[100svh] grid grid-cols-1 lg:grid-cols-2" data-testid="admin-login-page">
      <Toaster richColors position="top-right" />
      <aside className="hidden lg:block bg-ink text-cream relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1768818565983-29d3f4d76869?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" alt="" className="absolute inset-0 w-full h-full object-cover opacity-50 img-bw" />
        <div className="relative z-10 p-12 h-full flex flex-col justify-between">
          <img src="/brand/mmedia-logo-light.png" alt="M Media Corp" className="h-16 w-auto" draggable="false" />
          <div>
            <p className="serif-italic font-serif text-3xl">&ldquo;Discretion is the highest form of luxury.&rdquo;</p>
            <p className="overline text-cream/60 mt-4">Internal · Authorized personnel only</p>
          </div>
        </div>
      </aside>

      <main className="flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="admin-login-form">
          <div className="overline text-ink/55">Atelier Access</div>
          <h1 className="font-display uppercase text-6xl leading-[0.85] mt-3">Sign in.</h1>
          <p className="text-ink/70 mt-3">Internal lead intake for {COMPANY.name}.</p>

          <div className="mt-10">
            <label className="overline text-ink/55">Email</label>
            <input type="email" required className="editorial-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
          </div>
          <div className="mt-6">
            <label className="overline text-ink/55">Password</label>
            <input type="password" required className="editorial-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" />
          </div>

          <button type="submit" disabled={loading} className="btn-ink mt-10 w-full justify-center" data-testid="admin-login-submit">
            {loading ? "Authenticating…" : "Enter the atelier →"}
          </button>

          <a href="/" className="overline text-ink/50 hover:text-ink mt-8 inline-block">← Back to mmediacorp.com</a>
        </form>
      </main>
    </div>
  );
}
